import React from "react";
import { EmployeeMasterContextProvider } from "./EmployeeMasterView";
import EmployeeMaster from "./view/EmployeeMaster";
import EmployeeMasterContent from "../../constants/contentFile.json";

const EmployeeMasterpage = () => {
  return (
    <EmployeeMasterContextProvider>
       <EmployeeMaster textContent={EmployeeMasterContent.employeeMaster}/>
    </EmployeeMasterContextProvider>
  );
};

export default EmployeeMasterpage;
